import Layout from "./components/Layout";
import Chat from "../Tools/Chat";
import { useContext } from "react";
import UserContext from "../../services/Context/UserContext";
import { useState } from "react";
import Rpps from "../Inputs/Rpps";
import { LoadingButton } from "@mui/lab";
import API from '../../services/API'
import { Navigate, useParams } from "react-router-dom";
import { Box, Stack, Typography } from "@mui/material";
import Tracker from "../../services/Tracker";
import DpcError from "./components/DpcError";
import FindRpps from "./components/FindRpps";
import Conflict from "./components/Conflict";
import Timeline from "./components/Timeline";

export default function DpcFetch(){

    const { ref } = useParams()

    const { user, setUser } = useContext(UserContext)

    const [rpps, setRpps] = useState(user?.rpps || '')

    const [status, setStatus] = useState('loading')

    const [response, setResponse] = useState(null)

    const handleSubmit = e => {
        e.preventDefault();

        if(rpps === '10987654321') return setStatus('success'); // Testing

        setStatus('fetching');

        API.get(`/dpc/sync`)
            .then(() => API.get(`/dpc/fetch/${ref}/${rpps}`)
                .then(r => handleSuccess(r))
                .catch(e => handleError(e))
            )
            .catch(e => handleError(e))
        
        
    }

    const handleSuccess = r => {

        if(user) setUser({...user, rpps})

        track(r.data, user)

        setStatus('success')
    }

    const handleError = e => {

        setResponse(e.response)
        
        setStatus('error')
    }

    /** 
    if(status === 'success' && isDoubleDpc){

        const nextCourseId = window.localStorage.getItem('nextCourseId');

        const nextLink = cart.reward ? `/courses/${id}/success` : 
            `/dpc/success${nextCourseId ? `/${nextCourseId}` : ''}`;
        
        return <Navigate to={nextLink} />
    }

    if(status === 'success' && !isDoubleDpc){
        
        return <Navigate to={`/courses/${id}/success`} />
    }
    */

   
    if(status === 'success'){
        return <Navigate to={`/dpc/success`} />
    }

    return (
        <Layout>

            <form onSubmit={handleSubmit}>

                <Stack spacing={3} sx={{maxWidth: 700, margin: 'auto'}}>

                    <Timeline />

                    <Conflict />

                    <Typography >
                        Pour accéder à votre formation depuis notre plateforme, vous devez vérifier et confirmer votre numéro RPPS. Cela nous permet de faire le lien entre le DPC et LearnyLib.
                    </Typography>

                    <Rpps 
                        value={rpps}
                        onChange={rpps => setRpps(rpps)}
                        required
                        disabled={status === 'fetching'}
                    />

                    <Stack direction='row' justifyContent='space-between' spacing={1}>

                        <FindRpps />


                        <Box>
                            <LoadingButton 
                                variant='contained' 
                                type='submit'
                                loading={status === 'fetching'}
                                size='large'
                            >
                                {status === 'error' ? 'Réessayer' : 'Confirmer'}
                            </LoadingButton>
                        </Box>


                    </Stack>

                    {status=== 'error' &&

                        <DpcError status={response?.status} />
                    }

                </Stack>

            </form>

            <Chat />

        </Layout>
    );
}


function track(data, user){

    return Tracker.trackEnrollment({
        id: data?.id,
        value: data?.contribution,
        product: data?.course,
        mode: 'dpc',
        user: user
    });
}